import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataMoveOrdersToRoutesDtoModelBase } from './PlanningActionMetadataMoveOrdersToRoutesDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataMoveOrdersToRoutesDtoModel */
export interface PlanningActionMetadataMoveOrdersToRoutesDtoModelType extends Instance<typeof PlanningActionMetadataMoveOrdersToRoutesDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataMoveOrdersToRoutesDtoModel */
// eslint-disable-next-line max-len
export { selectFromPlanningActionMetadataMoveOrdersToRoutesDto, planningActionMetadataMoveOrdersToRoutesDtoModelPrimitives, PlanningActionMetadataMoveOrdersToRoutesDtoModelSelector } from './PlanningActionMetadataMoveOrdersToRoutesDtoModel.base';

/**
 * PlanningActionMetadataMoveOrdersToRoutesDtoModel
 */
export const PlanningActionMetadataMoveOrdersToRoutesDtoModel = PlanningActionMetadataMoveOrdersToRoutesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
